// src/pages/Instituicoes/PostsPage.js

import React from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import PostsList from '../../components/Instituicoes/PostsList'; // Corrigido para 'Instituicoes'
import useAuth from '../../hooks/useAuth';

const PostsPage = () => {
  const { instituicaoId } = useParams();
  const { user } = useAuth();

  // Verificar permissões se necessário

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Posts da Instituição
      </Typography>
      <PostsList instituicaoId={instituicaoId} />
    </Box>
  );
};

export default PostsPage;
